import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import GetQualityColumnClass from './GetQualityColumnClass';
import { Quality, QualityValue, QualityColumnType } from '../../../../Types/LotDetailQuality';
import BatchQualityDetailsDialog from '../../../../Dialogs/BatchQualityDetailDialog';
import { Row } from 'react-table';

export interface PrimaryCellProps {
    row: Row<Quality>,
    qualityType: string,
    qualityColumns: QualityColumnType[]
}

function PrimaryCell({ row, qualityType, qualityColumns }: PrimaryCellProps): React.JSX.Element {
    const [showBatchDetails, setShowBatchDetails] = useState(false);

    let batchValues = row.original.batchQualityValues;
    let value = "";
    let className = "";

    row.original.qualityValues.forEach(function (qualityValue: QualityValue) {
        if (qualityValue.testMethod === qualityType) {
            value = qualityValue.resultValue;
            className = GetQualityColumnClass(qualityValue) + " primary";
        }
    });

    const ValueContent = () => {
        return (row.original.batchQualityValues && row.original.batchQualityValues.length > 0 ?
            <Button variant="link" className={'quality-value-column link ' + className} onClick={() => setShowBatchDetails(true)}>{value}</Button> :
            <div className={'quality-value-column ' + className}>{value}</div>
        );
    }

    return (
        <>
            <ValueContent/>
            <BatchQualityDetailsDialog showDialog={showBatchDetails} closeDialog={() => setShowBatchDetails(false)} quality={row.original} batchQualityValues={batchValues} qualityColumns={qualityColumns} />
        </>
    );
}

export default PrimaryCell;